import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef, useState } from "react";
import SearchSVG from "../../../../components/UiKit/UiKitSVGs/SearchSVG";
import stl from "./SearchableGrid.module.css";
var SearchableGrid = function SearchableGrid(_ref) {
  var data = _ref.data,
    onChange = _ref.onChange,
    selectedValue = _ref.selectedValue,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    getData = _ref.getData,
    error = _ref.error,
    className = _ref.className,
    errorMsg = _ref.errorMsg,
    label = _ref.label,
    minLengthForSearch = _ref.minLengthForSearch;
  var UlRef = useRef();
  var _useState = useState(""),
    searchedText = _useState[0],
    setSearchedText = _useState[1];
  var _useState2 = useState(false),
    showErr = _useState2[0],
    setShowErr = _useState2[1];
  var combineTextSearch = function combineTextSearch(item, searchedTextF, idx) {
    if ((searchedTextF === null || searchedTextF === void 0 ? void 0 : searchedTextF.trim()) != "" && (data === null || data === void 0 ? void 0 : data.length) > 0) {
      var showText = item.name;
      if (searchedTextF.trim().length && searchedTextF.trim().length >= 1) {
        var startIndex = showText.indexOf(searchedTextF.trim()) != -1 ? showText.indexOf(searchedTextF.trim()) : showText.indexOf(searchedTextF.trim().split(" ")[0]);
        var endIndex = showText.indexOf(searchedTextF.trim()) != -1 ? searchedTextF.trim().length : searchedTextF.trim().split(" ")[0].length;
        var myWord = showText.substr(startIndex, endIndex);
        var finalArrText = [];
        var re = new RegExp(myWord.trim(), "g");
        showText = showText.replace(re, "<span style='font-weight: bold;' class='" + stl.boldWrtnText + "'>" + myWord.trim() + "</span>");
        finalArrText.push(showText);
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
          onClick: function onClick() {
            setSearchedText(item.name);
            getData(item);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: stl.wordBuilder
        }, (item === null || item === void 0 ? void 0 : item.image) && /*#__PURE__*/React.createElement("div", {
          className: stl.imageContainerS
        }, /*#__PURE__*/React.createElement("img", {
          src: item === null || item === void 0 ? void 0 : item.image,
          alt: "image"
        })), /*#__PURE__*/React.createElement("span", {
          className: "",
          dangerouslySetInnerHTML: {
            __html: finalArrText
          }
        }))));
      }
    }
  };
  useEffect(function () {
    selectedValue && setSearchedText(selectedValue);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: [stl.container, className ? className : undefined, showErr ? stl.mb40 : undefined, error || showErr ? stl.hasError : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("input", {
    placeholder: ".",
    onFocus: function onFocus() {
      return setShowErr(false);
    },
    disabled: disabled,
    type: "text",
    value: searchedText,
    onChange: function onChange(e) {
      setSearchedText(e.target.value);
    },
    onKeyDown: function onKeyDown(e) {
      (e.key === "Enter" || e.keyCode === 13) && e.target.blur();
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.iconContainer
  }, /*#__PURE__*/React.createElement(SearchSVG, {
    filledColor: "#154F9C"
  })), /*#__PURE__*/React.createElement("ul", {
    ref: UlRef,
    className: [stl.listitems, minLengthForSearch <= (searchedText === null || searchedText === void 0 ? void 0 : searchedText.length) ? undefined : stl.opac0].join(" ")
  }, data === null || data === void 0 ? void 0 : data.map(function (obj, idx) {
    return searchedText == "" ? /*#__PURE__*/React.createElement("li", {
      key: "search" + idx,
      onClick: function onClick() {
        setSearchedText(obj.name);
        getData(obj);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: stl.wordBuilder
    }, obj.image && /*#__PURE__*/React.createElement("div", {
      className: stl.imageContainerS
    }, /*#__PURE__*/React.createElement("img", {
      src: obj.image,
      alt: obj.name
    })), /*#__PURE__*/React.createElement("span", {
      className: ""
    }, obj.name))) : obj.name.indexOf(searchedText) > -1 && /*#__PURE__*/React.createElement(React.Fragment, {
      key: "search" + idx
    }, combineTextSearch(obj, searchedText, idx));
  })), (error || showErr) && /*#__PURE__*/React.createElement("p", {
    className: " ".concat(stl.error)
  }, showErr ? errorMsg : error), /*#__PURE__*/React.createElement("label", {
    className: stl.label
  }, label)));
};
export default SearchableGrid;